import { render, staticRenderFns } from "./assignment-tracker-filter.vue?vue&type=template&id=a850e51a&scoped=true&"
import script from "./assignment-tracker-filter.vue?vue&type=script&lang=ts&"
export * from "./assignment-tracker-filter.vue?vue&type=script&lang=ts&"
import style0 from "./assignment-tracker-filter.vue?vue&type=style&index=0&id=a850e51a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a850e51a",
  null
  
)

export default component.exports